import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { HowWeIntegrateSection } from "@/components/sections/HowWeIntegrateSection";
import { CTASection } from "@/components/sections/CTASection";

const HowWeWork = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <HowWeIntegrateSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HowWeWork;
